.input {
  text-align: center;
}
